import { useEffect, useState } from 'react';
import { useModel } from 'umi';
export default () => {
  const { info } = useModel('useActivity');
  const [productId, setProductId] = useState<Product.IBase['code']>();
  const [orderId, setOrderId] = useState<Activity.IBase['id']>();
  const [chooseReport, setChooseReport] = useState<{ key: REPORT.ReportType; id: string } | undefined>(undefined); //目前选中的报表
  const [refreshReportData, setRefreshReportData] = useState(new Date()); //该数据用来刷新报表数据
  const [refreshReportList, setRefreshReportList] = useState(new Date()); //该数据用来刷新报表目录列表
  useEffect(() => {
    info && setProductId(info?.product.code);
    info && setOrderId(info?.id);
  }, [info]);
  return {
    productId,
    orderId,
    chooseReport,
    setChooseReport,
    refreshReportData,
    setRefreshReportData,
    refreshReportList,
    setRefreshReportList
  };
};
